class CartNotification extends HTMLElement {
  constructor() {
    super();
    this.notification = document.getElementById('cart-notification');
    this.closeOverlay = this.querySelector('.cart_notification__close-overlay');
    this.header = document.querySelector('sticky-header');
    this.onBodyClick = this.handleBodyClick.bind(this);
    this.notification.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelectorAll('button[type="button"]').forEach((closeButton) =>
      closeButton.addEventListener('click', this.close.bind(this))
    );
    this.closeOverlay.addEventListener('click', this.close.bind(this));
  }

  connectedCallback() {
    this.addRemoveLineItemListener();
  }

  addRemoveLineItemListener() {
    this.notification.addEventListener('click', (event) => {
      if (event.target.classList.contains('remove-line-item')) {
        event.preventDefault();
        const variantId = event.target.getAttribute('data-variant');

        this.updateCart(variantId)
          .then(() => this.updateSections(this.getSectionsToRenderRemove()))
          .then(() => this.close())
          .catch((error) => {
            console.error('Error processing remove line item:', error);
          });
      }
    });
  }

  async updateCart(variantId) {
    try {
      const response = await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          id: variantId,
          quantity: 0,
        }),
      });
      return await response.json();
    } catch (error) {
      throw new Error('Error updating cart: ' + error.message);
    }
  }

  async updateSections(sections) {
    for (const section of sections) {
      try {
        const html = await this.fetchSectionHTML(section.id);
        this.updateSectionContent(section, html);
      } catch (error) {
        console.error('Error loading section:', error);
      }
    }
  }

  async fetchSectionHTML(sectionId) {
    const response = await fetch(`/?section_id=${sectionId}`);
    return await response.text();
  }

  updateSectionContent(section, html) {
    const sectionElement = document.getElementById(section.id);
    if (sectionElement) {
      const innerHTML = this.getSectionInnerHTML(html, section.selector);
      if (innerHTML) {
        sectionElement.innerHTML = innerHTML;
      }
    }
  }

  updateCartDrawer(cart) {
    this.renderContents({
      key: this.cartItemKey,
      sections: cart.sections,
    });
  }

  open() {
    this.setAttribute('open', '');
    document.body.classList.add('overflow-hidden');
    this.notification.classList.add('animate', 'active');
    this.classList.add('active-drawer');

    this.notification.addEventListener(
      'transitionend',
      () => {
        this.notification.focus();
        trapFocus(this.notification);
      },
      { once: true }
    );

    document.body.addEventListener('click', this.onBodyClick);
  }

  close() {
    this.removeAttribute('open');
    document.body.classList.remove('overflow-hidden');
    this.notification.classList.remove('active');
    this.classList.remove('active-drawer');
    document.body.removeEventListener('click', this.onBodyClick);
    removeTrapFocus(this.activeElement);
  }

  renderContents(parsedState) {
    this.cartItemKey = parsedState.key;

    this.getSectionsToRender().forEach((section) => {
      const sectionElement = document.getElementById(section.id);
      const sectionHTML = parsedState.sections[section.id];

      if(sectionElement) {
        const innerHTML = this.getSectionInnerHTML(sectionHTML, section.selector);
        if (innerHTML) {
          sectionElement.innerHTML = innerHTML;
        }
      }

    });

    if (this.header) this.header.reveal();
    this.open();
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-notification-product',
        selector: `[id="cart-notification-product-${this.cartItemKey}"]`,
      },
      {
        id: 'cart-notification-button',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionsToRenderRemove() {
    return [
      {
        id: 'cart-notification-button',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  handleBodyClick(evt) {
    const target = evt.target;
    if (target !== this.notification && !target.closest('cart-notification')) {
      const disclosure = target.closest('details-disclosure, header-menu');
      this.activeElement = disclosure ? disclosure.querySelector('summary') : null;
      this.close();
    }
  }

  show(focusElement) {
    this.focusElement = focusElement;
    this.setAttribute('open', '');
    document.body.addEventListener('click', this.onBodyClick);
    document.body.classList.add('overflow-hidden');
    trapFocus(this);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-notification', CartNotification);
